import { APP_CONFIG } from '@core/configs';
import { environment } from '@environments/environment';

// export const API_BASE_URL = APP_CONFIG.apiBaseUrl;
export const API_BASE_URL = environment.CLIENT_API;
export const API_CAREMONI_WEB_URL = environment.CAREMONI_WEB_API;
export const TOKEN_URL = APP_CONFIG.tokenUrl;
export const API_TOKEN_URL = environment.API_TOKEN_URL;
export const REFRESH_TOKEN_URL = environment.REFRESH_TOKEN;

export const API_ENDPOINT = {
  authConsole: {
    base: API_BASE_URL + 'auth',
    refreshToken: API_BASE_URL + 'auth/refresh',
    logout: API_BASE_URL + 'auth/logout',
    login: API_BASE_URL + 'auth/login',
    get_organizations: API_BASE_URL + 'corp/get-organizations',
    checkResourcePolicy: API_BASE_URL + 'resource-policy/check-resource-policy',
    getAllCorp: API_BASE_URL + 'corp/get-all-corp',
    getOfficeByOrganizationIds: API_BASE_URL + 'migration/get-offices-by-organization-ids',
    updateDynamoDB: API_BASE_URL + 'corp/set-offices-info',
    updateSingleOffice: API_BASE_URL + 'corp/set-single-offices-info',
    deleteSingleOffice: API_BASE_URL + 'corp/delete-single-office',
    setForceLogoutVersionByOffice: API_CAREMONI_WEB_URL + 'realtimedb/set-force-logout-version-by-office',
    // MenuTV - DynamoDB
    menuTvItems: API_BASE_URL + 'menuTV/items',
    menuTvCategories: API_BASE_URL + 'menuTV/categories',
    uploadFileToS3: API_BASE_URL + 'menuTV/upload-file-item-menu-tv',
    deleteMediaFile: API_BASE_URL + 'menuTV/delete-media-file',
    menuTvCategoriesReorder: API_BASE_URL + 'menuTV/categories/reorder',
    // Device management
    getAllDevices: API_BASE_URL + 'device/get-all-devices',
    updateDeviceLogEnabled: API_CAREMONI_WEB_URL + 'device-licenses/update-log-enabled-by-device-ids',
    setOfficeLogEnabled: API_CAREMONI_WEB_URL + 'office-logs/set-by-devices',
    checkVersion: API_CAREMONI_WEB_URL + 'firebase/check-version',
    reloadWebVersionByDeviceTokens: API_CAREMONI_WEB_URL + 'firebase/reload-web-version-by-device-tokens',
    getDeviceAppLogs: API_BASE_URL + 'device/get-app-logs',
  }
};

export const TOKEN_API_ENDPOINT = {
  login: API_TOKEN_URL + "/user/login",
  refreshToken: API_TOKEN_URL + "/ck-pass/token/refresh",
  verifyRefreshToken: API_TOKEN_URL + "/ck-pass/token/verify-refresh-token",
  logout: API_TOKEN_URL + "/token/logout",
};
